   document.addEventListener('DOMContentLoaded', function() {
            const popup = document.getElementById('popup');
            const closeBtn = document.getElementById('closePopup');
            
            // Controlla se il popup deve essere mostrato
            function shouldShowPopup() {
            //    // Controlla il localStorage per vedere quando è stato mostrato l'ultima volta
                const lastShown = localStorage.getItem('popupLastShown');
                
            //    // Controlla sessionStorage per vedere se è già stato mostrato in questa sessione
                const shownInSession = sessionStorage.getItem('popupShownInSession');
                
                if (shownInSession === 'true') {
                    return false; // Già mostrato in questa sessione
                }
                
                if (lastShown) {
                    const lastShownTime = new Date(lastShown).getTime();
                    const currentTime = new Date().getTime();
                    const twentyFourHours = 24 * 60 * 60 * 1000; // 24h in millisecondi
                    
                    if (currentTime - lastShownTime < twentyFourHours) {
                        return false; // Meno di 24 ore dall'ultima visualizzazione
                    }
                }
                
                return true; // Mostra il popup
            }
            
            // Mostra il popup se necessario
            if (shouldShowPopup()) {
                popup.style.display = 'flex';
                
                // Memorizza che è stato mostrato in questa sessione
                sessionStorage.setItem('popupShownInSession', 'true');
                
                // Memorizza l'ora corrente nel localStorage
                localStorage.setItem('popupLastShown', new Date().toISOString());
            }
            
            // Chiudi il popup quando si clicca sul pulsante di chiusura
            closeBtn.addEventListener('click', function() {
                popup.style.display = 'none';
            });
            
            // Chiudi il popup quando si clicca fuori dal contenuto
            popup.addEventListener('click', function(e) {
                if (e.target === popup) {
                    popup.style.display = 'none';
                }
            });
        });